export const CONTROL = 'control' as const;
export const TEST = 'test' as const;

export type VariantType = typeof CONTROL | typeof TEST;
export type PayloadsType<T = boolean, V extends string = VariantType> = Record<V, T>;

export type MultiVariantModuleConfig<T = boolean, V extends VariantType = VariantType> = {
  Name: string;
  Payloads?: PayloadsType<T, V>;
  BootstrapVariant?: VariantType;
};
